<template>
  <div class="main-container flex flex-center">
    <div class="main-box">
      <!--头部导航-->
      <div class="box-header flex flex-center">
        <div class="box-header-left flex flex-center">
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 1 }"
            @click="activeChange(1, 'time')"
            >{{ $t("m.options.listTab.time") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 2 }"
            @click="activeChange(2, 'name')"
            >{{ $t("m.options.listTab.name") }}</span
          >
          <span
            class="header-span"
            :class="{ 'header-span-active': active1 == 3 }"
            @click="activeChange(3, 'score')"
            >{{ $t("m.options.listTab.rating") }}</span
          >
        </div>
        <div class="box-header-right">
          <div class="box-header-right">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="active-icon"
              @click="dialogTableVisible3 = true"
            ></el-button>
            <el-button
            type="primary"
            icon="el-icon-plus"
            class="active-icon"
            @click="createComment"
            >{{ $t("m.options.listTab.create") }}</el-button
          >
          </div>
        </div>
      </div>
      <!--内容-->
      <div style="height: calc(100% - 55px);">
        <div class="box-content">
        <div
          @click="checkDevice(item)"
          :class="[
            item.id == selectCommentId
              ? 'box-item box-half box-bc box-active'
              : 'box-item box-half box-bc',
          ]"
          v-for="item in commentList"
          v-bind:key="item.id"
        >
          <div class="box-item-text">
            <div class="box-item-title">
              {{ item.score }}{{ $t("m.chart.table.score") }}
            </div>
            <div>
              <span class="gray-text"
                >{{ $t("m.cupEvaluate.table.name") }}: </span
              ><span class="white-text">{{ item.name }}</span>
            </div>
            <div>
              <span class="gray-text">{{ $t("m.chart.table.date") }}：</span
              ><span class="white-text">{{
                $moment(Number(item.updatetime)).format("YYYY-MM-DD")
              }}</span>
            </div>
          </div>
        </div>
      </div>
        <div class="table-footer">
          <el-pagination
              background
              align="right"
              layout="prev, pager, next"
              @current-change="cupPageChange"
              :page-size="page.pageSize"
              :total="page.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <div class="main-box border-1px-all">
      <comment-detail
        @finish="commentDetailLoadingFinish"
        :chart="showChart"
        :suit-id="selectSuitId"
        :comment-id="selectCommentId"
        :edit="false"
        :isAdd="isAdd"
        :cupUser="cupUser"
      ></comment-detail>
    </div>

    <!--------搜索弹框---------->
    <el-dialog
      :title="$t('m.chart.table.search')"
      :visible.sync="dialogTableVisible3"
      width="500px"
      :show-close="false"
    >
      <div>
        <div class="flex flex-center flex-between" style="margin-bottom:10px;">
          <span class="search-dialog-title">{{
            $t("m.options.listTab.name")
          }}</span>
          <el-input
            :placeholder="$t('m.chart.table.placeholder3')"
            v-model="searchCommentName"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="flex flex-center">
        <div @click="dialogTableVisible3 = false" class="dialog-footer-btn">
          {{ $t("m.chart.table.cancel") }}
        </div>
        <div type="primary" @click="changeTab1" class="dialog-footer-btn">
          {{ $t("m.chart.table.confirm") }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commentDetailComponent from "@/components-online/cupping/commentDetailComponent";
export default {
  name: "equipment-list",
  components: {
    "comment-detail": commentDetailComponent,
  },
  data() {
    return {
      isAdd: false,
      commentDetailDialog: false,
      orderParamKey: "/manage/comment/getListByUserOrderbyName.do",
      orderParamsKeyOptions: [
        {
          value: "/manage/comment/getListByUserOrderbyName.do",
          label: "首字母",
        },
        {
          value: "/manage/comment/getListByUserOrderbyScore.do",
          label: "分数",
        },
      ],
      sortUrl: [
        [
          {
            value: "/manage/comment/getListByUserOrderbyName.do",
            label: "首字母",
          },
          {
            value: "/manage/comment/getListByUserOrderbyScore.do",
            label: "分数",
          },
        ],
        [
          {
            value: "/manage/comment/getListAllOrderbyName.do",
            label: "首字母",
          },
          { value: "/manage/comment/getListAllOrderbyScore.do", label: "分数" },
        ],
      ],
      commentList: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      url: "/manage/comment/getListAll.do", //不带参数的搜索url
      searchUrl: "/manage/comment/searchAllByName.do", //但参数的url,
      params: {
        params: {
          pageSize: 20,
          pageNum: 1,
        },
      },
      searchCommentName: "",
      selectCommentIds: [],
      selectCommentId: 0,
      refreshCommentDetail: false,
      editCommentDetailDialog: false,
      activeUrl: "/manage/comment/getListAll.do",
      selectSuitId: 0,
      showChart: true,
      loading: undefined,

      active1: 1,

      name: "",
      date: "",
      selectValue: "",
      options: [
        {
          label: "等级一",
          value: "1",
        },
        {
          label: "等级二",
          value: "2",
        },
      ],
      sliderValue: 30,
      num1: 3,
      num2: 0,
      num3: 0,
      dialogTableVisible3: false,
      moveFlag: false,
      column: 'time',
      cupUser: true,
    };
  },
  mounted() {
    if (localStorage.role != 1) {
      this.cupUser = false;
    }
    this.changeTab1();
  },
  methods: {
    checkDevice(item) {
      this.selectCommentId = Number(item.id);
      if (item.type == 'V1') {
        this.selectSuitId = Number(item.suitid);
      } else {
        this.selectSuitId = Number(item.curveId);
      }
   
      this.refreshCommentDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
    },
    commentDetailLoadingFinish() {
      // this.loading.close()
    },
    changeTab1() {
      const url = "/manage/comment/list";
      let params = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        keyword: this.searchCommentName,
        sort: {
          column: this.column
        }
      }
      this.$http
        .post(url, params)
        .then(
          function(resp) {
            if (resp.data.success) {
              this.commentList = resp.data.data.list;
              this.page.total = resp.data.data.total;

              this.selectCommentId = Number(resp.data.data.list[0].id);
              if (resp.data.data.list[0].type == 'V1') {
                this.selectSuitId = Number(resp.data.data.list[0].suitid);
              } else {
                this.selectSuitId = Number(resp.data.data.list[0].curveId);
              }
              console.log(this.selectSuitId)
              this.refreshCommentDetail = false;
              // 在组件移除后，重新渲染组件
              // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
              this.$nextTick(() => {
                this.refreshCommentDetail = true;
              });
            } else {
              this.$message.error(this.$t("m.alert.error"));
            }
          }.bind(this)
        )
        .catch((err) => {
          console.info(err);
        });
    },
    cupPageChange(val) {
      console.info(val);
      this.page.pageNum = val;
      this.changeTab1();
    },
    activeChange(e, val) {
      this.active1 = e;
      this.column = val;
      this.changeTab1();
    },
    createComment() {
      this.isAdd = true;
      this.selectCommentId = 0;
      this.refreshCommentDetail = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.refreshCommentDetail = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-footer {
  position: sticky;
  bottom: 0;
  background: #1a1b1c29;
  padding-top: 10px;
}
.box-content {
  gap: 15px;
}
.box-item.box-half {
  width: calc(50% - 10px) !important;
}
</style>